import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";
import AllProjects from "../components/projects/allProjects";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/projects.css";

const Projects = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "projects");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Projects | ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="projects" />
				<div className="content-wrapper">
					<div className="projects-logo-container">
						<div className="projects-logo">
							<Logo width={46} />
						</div>
					</div>
					<div className="projects-container">
						<div className="title projects-title">
							Pequenos projetos realizados com o intuito de aplicar os conceitos aprendidos.
						</div>

						<div className="subtitle projects-subtitle">
							Desde que escrevi meu primeiro Hello World aprendi muito sobre programação e venho buscando aprender mais ainda.
							Reconheço que já ultrapassei muitas barreiras e que ainda existem muitas outras para serem ultrapassadas, 
							como pode ser observado nos defeitos presentes nos projetos, 
							estou buscando por mais conhecimento através dos mais sábios na área. 
							"Ouça conselhos e aceite instruções, e acabará sendo sábio."
							Provérbios 19:20
						</div>

						<div className="projects-list">
							<AllProjects />
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default Projects;
